import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-storage-parent-list',
  templateUrl: './storage-parent-list.component.html',
  styleUrls: ['./storage-parent-list.component.scss']
})
export class StorageParentListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
